import { useStorage } from '~library/composables'
import { LocalStorage } from '~library/enums'

export function useReload() {
  const { getStorageKey } = useStorage()

  const storageListenerReload = () => {
    addEventListener('storage', (event) => {
      if (
        event.key !== getStorageKey(LocalStorage.USER_PROFILE) &&
        event.key !== getStorageKey(LocalStorage.USER_PROFILE_IDENTITY)
      ) {
        return
      }

      window.location.reload()
    })
  }

  return { storageListenerReload }
}
